module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_6.ef05192e.png";